document.addEventListener('DOMContentLoaded', () => {
    const blockTilesEdoreczenia = document.querySelector('.block-tiles-edoreczenia');

    const cardList = blockTilesEdoreczenia?.querySelectorAll('.services-row .card');

    if (cardList) {
        cardList.forEach(card => {
            const buttonTilesReveresShow = card.querySelector('.bsct-tile-show-reverse');

            buttonTilesReveresShow?.addEventListener('click', () => {
                card.toggleAttribute('open');
            });
        })
    }
});